// Menu Exports
export const mobileMenuId = 'primary-search-account-menu-mobile';

// Drawer Exports
export const drawerTitle = 'Farmrail';
export const drawerWidth = '240px';
export const DRAWER_ERROR = 'DRAWER_ERROR';
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const CHANGE_DRAWER = 'CHANGE_DRAWER';

export const UPDATE_AUTH = 'UPDATE_AUTH';

// Login states for the application
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// Log out states for the application
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// Product states for the application
export const PRODUCT_SEARCH = 'PRODUCT_SEARCH';
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';